import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import MDTypography from "dashboard/components/MDTypography";
import ProjectSlideItem from "components/Home/child-components/ProjectSlideItem";

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 3,
    partialVisibilityGutter: 40
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 1,
    partialVisibilityGutter: 30
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 2,
    partialVisibilityGutter: 30
  }
};

const project = ({data, parseContent}) => {
  return (
    <section id="Projects" className="project-section">
        <div className="section-title">
          <h2 style={{textAlign:"center"}}>{data ? data.title : "...loading"}</h2>
          <MDTypography sx={{my:3, textAlign:"center", textTransform :"uppercase"}} variant="h1">Travail réussi de GRANITEX</MDTypography>
        </div>    
        <Carousel
          additionalTransfrom={0}
          arrows={false}
          autoPlaySpeed={4000}
          centerMode={false}
          className=""
          containerClass="container-with-dots"
          dotListClass="slick-dots"
          draggable
          focusOnSelect={false}
          infinite={false}
	      	autoPlay
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={responsive}
          showDots
          rewind={true}
          rewindWithAnimation={true}
          rtl={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
          >
              {data
                ? data.cards?.map((d, i) => (
                    <ProjectSlideItem key={`${d.title}-${i}`} 
                      to={d.link ? d.link.slug : ""}
                      img={`${process.env.REACT_APP_PUBLIC_URL}/img/features/${d.img}`}
                      title={d.title}
                      content={parseContent(d.text.substring(0,150))}
                    />
                ))
              : "Loading..."}
          </Carousel>
    </section>
  )
}

export default project